import React from "react";
import "./Wishlist.scss";
import { useStateValue } from "../context/StateProvider";
import Product from "./Product";
import WishlistImg from "../assets/wishlist.svg";
import { Link } from "react-router-dom";

function Wishlist() {
  const [{ wishlist }] = useStateValue();

  return (
    <div className="wishlist">
      <h4>Wishlist</h4>
      {wishlist.length > 0 ? (
        <div className="products">
          {wishlist.map((product) => (
            <Product id={product.id} key={product.id} item={product} />
          ))}
        </div>
      ) : (
        <div className="cart__inner wishlist__inner">
          <div className="cart__items">
            <img src={WishlistImg} className="cart__empty" alt="" />
          </div>
          <div className="cart__checkout">
            <h4>It's empty here.</h4>
            <p style={{ marginBottom: "3rem" }}>
              Something's catching your eye? Add your favorite items to
              wishlist, and check them out anytime you wish.
            </p>
            <div className="buttons">
              <Link to="/">
                <button className="buttonPrimary">Go Shopping</button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Wishlist;
